import { VideoResolutions } from "@swo/shared";
import { pipe } from "fp-ts/function";
import { nonEmptyArray } from "fp-ts";

export function findBestVideoWidth(
  requestedWidth: number,
  availableVideoVariants: VideoResolutions["variants"],
  resolutionPickerStrategy: "middle" | "ceil" | "double-ceil" | number,
): VideoResolutions["variants"][0] {
  if (resolutionPickerStrategy === "middle" || typeof resolutionPickerStrategy === "number") {
    const m = pipe(
      availableVideoVariants,
      nonEmptyArray.map(v => ({
        ...v,
        distance:
          resolutionPickerStrategy === "middle"
            ? Math.abs(v.width - requestedWidth)
            : Math.abs(v.width - requestedWidth * resolutionPickerStrategy),
      })),
    );

    const sorted = m.sort((a, b) => a.distance - b.distance);

    return sorted[0];
  } else {
    const m = pipe(
      availableVideoVariants,
      nonEmptyArray.map(v => ({ ...v, distance: v.width - requestedWidth })),
    );

    const sorted = m.sort((a, b) => a.distance - b.distance);

    const idxs = resolutionPickerStrategy === "ceil" ? [1] : resolutionPickerStrategy === "double-ceil" ? [2, 1] : [];

    const x = idxs.reduce((acc, i) => {
      return sorted[i] || acc;
    }, sorted[0]);

    return x;
  }
}
